import axios from 'axios';
export const getDomainDetails = (root, organizationId) => axios.get(`${root}/organization/${organizationId}/domain-details`).then((r) => r.data);
//# sourceMappingURL=custom-domains.js.map